import { createContext } from "react";

export const ArtisanContext = createContext()